import {
  withTranslation,
} from 'react-i18next';

import CrewmemberFieldsView from './CrewmemberFieldsView';

const TranslatedComponent = withTranslation()(CrewmemberFieldsView);

const Component = TranslatedComponent;

export default Component;
